import { render } from "./CreateEventModal.vue?vue&type=template&id=987f4fa0&scoped=true"
import script from "./CreateEventModal.vue?vue&type=script&lang=js"
export * from "./CreateEventModal.vue?vue&type=script&lang=js"

import "./CreateEventModal.vue?vue&type=style&index=0&id=987f4fa0&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-987f4fa0"]])

export default __exports__